import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideNotificationOverflow } from "../../../actions/ui";
import LockOverlay from "../../vapor/lockOverlay";
import Notification from "../../vapor/notification";
import { Button } from "@vapor/react-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.scss";
import { FormattedMessage } from "react-intl";
import { FEATURE_TOGGLE_DEV } from "../../../config";

const UIelements = () => {
    const ui = useSelector((state: RootState) => state.ui);
    const userPackage = useSelector((state: RootState) => state.userPackage);
    const onboarding = useSelector((state: RootState) => state.onboarding);
    const modebisconfig = useSelector(
        (state: RootState) => state.modebisconfig,
    );
    const dispatch = useDispatch();

    return (
        <>
            {!userPackage?.isLoadingPackage &&
                modebisconfig?.trial &&
                !onboarding.forceOnboarding && (
                    <div className="vapor-bi-trialwarning-container">
                        <div className="vapor-bi-trialwarning-icon">
                            <FontAwesomeIcon
                                icon={["fas", "triangle-exclamation"]}
                            />{" "}
                        </div>
                        <div className="vapor-bi-trialwarning-message">
                            {!modebisconfig?.readOnly ? (
                                <FormattedMessage
                                    id={
                                        modebisconfig?.trialExpire &&
                                        modebisconfig?.trialExpire > -1
                                            ? "trial.message"
                                            : "trial.messageSoon"
                                    }
                                    values={{
                                        days: modebisconfig?.trialExpire,
                                    }}
                                />
                            ) : (
                                <FormattedMessage id="trial.messageExpired" />
                            )}
                        </div>
                        {FEATURE_TOGGLE_DEV === "true" && (
                            <div className="vapor-bi-trialwarning-button-invisible">
                                <Button
                                    size="small"
                                    variant="contained"
                                    onClick={() => {
                                        dispatch({
                                            type: "FORCE_ONBOARDING",
                                        });
                                    }}
                                >
                                    TO
                                </Button>
                            </div>
                        )}
                        <div className="vapor-bi-trialwarning-button">
                            <Button
                                size="small"
                                variant="contained"
                                onClick={() => {
                                    window.open(
                                        "https://www.teamsystem.com/store/business-information/prezzi/",
                                        "_blank",
                                    );
                                }}
                            >
                                <FormattedMessage id="trial.button" />
                            </Button>
                        </div>
                    </div>
                )}
            {ui.notificationOverflow && (
                <Notification
                    title={ui.notificationOverflowData.title}
                    duration={ui.notificationOverflowData.duration}
                    variant={ui.notificationOverflowData.type}
                    onClose={() => dispatch(hideNotificationOverflow())}
                >
                    {ui.notificationOverflowData.message}
                </Notification>
            )}
            {ui.lockOverlay && (
                <LockOverlay
                    showSpinner={ui.lockOverlayData.showSpinner}
                    message={ui.lockOverlayData.message}
                />
            )}
        </>
    );
};

export default UIelements;
